import React from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { Link } from "react-router-dom";

const CollapseMenu = ({ handleNavbar, isOpen, anchorEl }) => {
  return (
    <>
      <Menu
        id="long-menu"
        keepMounted
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleNavbar}
        PaperProps={{
          style: {
            width: "250px",
            height: "100%",
            position: "fixed",
          },
        }}
      >
        <MenuItem>
          <Link  style={{'textDecoration': 'none'}} to="/cat-delivery" onClick={() => handleNavbar()}>
            Cat delivery
          </Link>
        </MenuItem>
        <MenuItem>
          <Link  style={{'textDecoration': 'none'}} to="/book-visit" onClick={() => handleNavbar()}>
            Book a visit
          </Link>
        </MenuItem>
        <MenuItem>
          <Link style={{'textDecoration': 'none'}} to="/donate" onClick={() => handleNavbar()}>
            Donate
          </Link>
        </MenuItem>
      </Menu>
    </>
  );
};
export default CollapseMenu;
